var map = {
	"./ExitContainer.png": 35855,
	"./ExitContainer1.png": 68022,
	"./ExitTag.png": 35966,
	"./FixedButton.png": 11456,
	"./arkadium.png": 90058,
	"./discord.png": 85002,
	"./game-default.png": 89998,
	"./instagram.png": 61222,
	"./spotify.png": 32296,
	"./tiktok.png": 29198,
	"./twitter.png": 59355,
	"./webrcade.png": 98649,
	"./youtube.png": 52541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9685;